<template>
  <el-dialog
    title="修改客户邮箱"
    :visible.sync="visible"
    width="560px"
    :before-close="handleClose"
    custom-class="fabric-library-dialog">
    <div style="color:red;margin-bottom:20px">修改的是系统所有面料的客户邮箱</div>
    <div class="f--c">
      <div style="width:100px;text-align:right;flex-shrink: 0;">客户邮箱</div>
      <el-select v-model="userIds" size="medium" collapse-tags multiple filterable remote reserve-keyword placeholder="客户邮箱" class="default-maggin-left" style="width: 70%;margin-left: 15px" :remote-method="userRemoteMethod" :loading="getUserLoading" @focus="handleFocus" clearable>
        <el-option v-for="item in userOptions" :key="item.userId" :label="`${item.email||''}${(item.email&&item.phone?' / ':'')}${item.phone||''}`" :value="item.userId" :title="`${item.email||''}${item.phone?' / '+item.phone:''}`" />
      </el-select>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
export default {
  data() {
    return {
      visible: false,
      userOptions: [],
      userIds: [],
      getUserLoading: false
    }
  },
  props: {
    kkCustomerEmails: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    show() {
      this.visible = true
      this.getUserOptions('init', {
        email: '',
        pageNumber: 1,
        pageSize: 20,
        users: []
      })
    },
    userRemoteMethod(query) {
      if (typeof query !== 'string') {
        query = ''
      }
      const params = {
        email: query ? query.trim() : '', // 查询关键字
        pageNumber: 1,
        pageSize: 20,
        users: [],
        // userIds: this.parameter.userIds || []
      }
      this.getUserOptions('remote-method', params)
    },
    handleFocus() {
      this.getUserOptions('focus', {
        email: '',
        pageNumber: 1,
        pageSize: 20,
        users: []
      })
    },
    getUserOptions(type, params) {
      this.getUserLoading = true
      API.getUserOptions(params).then(res => {
        if (['focus', 'init'].includes(type)) {
          let arr = this.kkCustomerEmails
          let list = res.data.list
          _.pullAllBy(list, arr, 'email')
          this.userOptions = arr.concat(list)
        }
        if (type === 'init') {
          this.userIds = this.kkCustomerEmails.map(t => t.userId)
        }
        if (type === 'remote-method') {
          this.userOptions = res.data.list
        }
      }).finally(() => {
        this.getUserLoading = false
      })
    },
    handleClose() {
      this.userIds = []
      this.visible = false
    },
    handleConfirm() {
      if (!this.userIds || this.userIds.length === 0) {
        return this.$message.warning('请选择客户邮箱')
      }
      API.putFabricKkCustomerEmail({ userIds: this.userIds }).then(res => {
        this.$message.success('修改成功')
        this.handleClose()
        this.$emit('editEmailSuccess')
      })
    },
  }
}
</script>

<style lang="scss">
.fabric-library-dialog {
  .el-dialog__body {
    padding: 10px 20px 16px 20px ;
  }
}
</style>
